import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ConstrainProportionsOffIcon = function ConstrainProportionsOffIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ConstrainProportionsOffIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.684 11.369c0 .5.223.996.65 1.376.429.382 1.027.608 1.666.608s1.237-.226 1.667-.608c.211-.188.374-.408.484-.643s.165-.484.165-.733v-1.31c0-.455.377-.824.842-.824s.842.369.842.824v1.31c0 .488-.108.97-.316 1.416s-.51.845-.885 1.178C10.044 14.636 9.036 15 8 15s-2.044-.365-2.8-1.037C4.444 13.29 4 12.36 4 11.37v-1.31c0-.455.377-.824.842-.824s.842.369.842.824zm-.842-4.604A.833.833 0 0 1 4 5.94v-1.31c0-.488.108-.97.316-1.416s.51-.845.885-1.179a4 4 0 0 1 1.294-.77C6.974 1.09 7.485 1 8 1s1.026.09 1.505.267c.48.176.92.437 1.294.77.375.333.677.732.885 1.178S12 4.143 12 4.631v1.31a.833.833 0 0 1-.842.824.833.833 0 0 1-.842-.824v-1.31c0-.249-.055-.498-.165-.733a2 2 0 0 0-.484-.643 2.4 2.4 0 0 0-.755-.447 2.64 2.64 0 0 0-1.824 0 2.4 2.4 0 0 0-.755.447 2 2 0 0 0-.484.643c-.11.235-.165.484-.165.733v1.31a.833.833 0 0 1-.842.824",
      clipRule: "evenodd"
    })
  }));
};

export { ConstrainProportionsOffIcon };
